import { Overrides } from '@material-ui/core/styles/overrides';

import { capeCodGray } from './palette';
import { typography } from './typography';

export const overrides: Overrides = {
  MuiCardHeader: {
    root: {
      padding: '24px 32px',
    },
    title: {
      ...typography.subtitle1,
      fontWeight: 'bold',
    },
  },
  MuiPaper: {
    elevation1: {
      boxShadow: '0 3px 4px 0 rgba(10, 31, 68, 0.1), 0 0 1px 0 rgba(10, 31, 68, 0.08)',
    },
  },
  MuiTabs: {
    flexContainer: {
      borderBottom: '2px solid #eaf2f2',
    },
  },
  MuiTab: {
    root: {
      fontSize: '13px',
      textTransform: 'capitalize',
      fontWeight: 100,
      '&:hover': {
        fontWeight: 500,
      },
      '&$selected': {
        fontWeight: 500,
      },
    },
  },
  MuiInput: {
    root: {
      fontSize: 12,
      fontWeight: 'bold',
    },
    underline: {
      '&:before': {
        borderBottomWidth: 0,
      },
    },
  },
  MuiTablePagination: {
    select: {
      ...typography.body2,
      minHeight: '10px',
      height: '10px',
    },
  },
  MuiInputLabel: {
    root: {
      color: capeCodGray,
    },
  },
  MuiFormLabel: {
    root: {
      color: capeCodGray,
      fontSize: 12,
      marginBottom: 8,
      display: 'block',
      fontWeight: 500,
      '&$focused': {
        color: capeCodGray,
      },
    },
  },
};
